<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-12 mb-2"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="changeName($event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.slug"
            :external-errors="errors['slug']"
            :label-form="'Slug' | translate"
            class-form="col-12 mb-2"
            type="text"
            :value="form.slug"
            :disabled="!formEditable"
            @change="$set(form, 'slug', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.description"
            :external-errors="errors['description']"
            :label-form="'Description' | translate"
            class-form="col-12 mb-2"
            type="text"
            :value="form.description"
            :disabled="!formEditable"
            @change="$set(form, 'description', $event)"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
        <b-button
          class="mr-3"
          variant="default"
          @click.prevent="formEditable ? cancel() : closeForm()">
          {{ formEditable ? 'Cancel' : 'Close' | translate }}
        </b-button>
        <b-button
          variant="primary"
          v-has-perms="editRolePerm"
          @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
          :disabled="$v.form.$invalid">
          {{ formEditable ? 'Save' : 'Edit' | translate }}
        </b-button>
      </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { TYPES as PROJECT_TYPE_TYPES } from './store'

import slugify from 'slugify'

import ThuxDetailPanelMixin from '../../../components/thux-detail-panel/ThuxDetailPanelMixin'

export default {
  name: 'ProjectTypeEdit',
  mixins: [ThuxDetailPanelMixin],
  data () {
    return {
      pageName: 'Project type',
      rolePerm: 'project_projecttype_retrieve',
      editRolePerm: 'project_projecttype_update'
    }
  },
  computed: {
    ...mapGetters({
      ...PROJECT_TYPE_TYPES.GENERIC.project.projecttype.DETAIL.GETTERS
    })
  },
  components: { },
  methods: {
    ...mapActions({
      ...PROJECT_TYPE_TYPES.GENERIC.project.projecttype.DETAIL.ACTIONS
    }),
    changeName (evt) {
      this.$set(this.form, 'name', evt)
      if (this.formEditable) {
        this.setSlug()
      }
    },
    setSlug () {
      this.$v.form.name.$touch()
      if (this.form.name) {
        this.$set(this.form, 'slug', slugify(this.form.name, { remove: /[*+~.()'"!:@]/g }))
      } else {
        this.$set(this.form, 'slug', undefined)
      }
    }
  },
  validations: {
    form: {
      name: { required },
      slug: { required },
      description: {}
    }
  }
}
</script>
